export default "__VITE_ASSET__BgeJHY1c__"